import gql from 'graphql-tag';

// Query used to get the create a Verifone account in PAPI
export const createVerifoneAccount = gql`
	mutation createVerifoneAccount($input: VerifoneAccountInput) {
		createVerifoneAccount(input: $input) {
			merchantId
			verifoneSerialNumber
			isVerifoneDeviceKeyPresent
		}
	}
`;

export const deleteVerifoneAccount = gql`
	mutation deleteVerifoneAccount($locationId: ID, $confirmationText: String) {
		deleteVerifoneAccount(
			locationId: $locationId
			confirmationText: $confirmationText
		){
			errmsg
		}
	}
`;

export const getVerifoneAccount = gql`
	query verifoneAccount($locationId: ID) {
		verifoneAccount(locationId: $locationId) {
			merchantId
			verifoneSerialNumber
			isVerifoneDeviceKeyPresent
		}
	}
`;

// Query used to retrieve list of cardconnect terminals
export const listVerifoneTerminals = gql`
	query verifoneTerminals {
		verifoneTerminals {
			terminalId
			terminalName
		}
	}
`;

// Mutation used to update a cardconnect Terminal in PAPI
export const updateVerifoneTerminal = gql`
	mutation updateVerifoneTerminal($input: VerifoneTerminalInput) {
		updateVerifoneTerminal(input: $input) {
			terminalId
			terminalName
		}
	}
`;

export default {
	createVerifoneAccount,
	deleteVerifoneAccount,
	getVerifoneAccount,
	listVerifoneTerminals,
	updateVerifoneTerminal,
};
